import React, { useEffect, useState } from "react";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-dawn";
import { getHeaderValueByKey } from "../../../../../../common/utils/header.util";
import { ContentType } from "../../../../../../common/interfaces/flow/action/WebRequestAction";
import { useSelector } from "react-redux";
import { getAceEditorTheme } from "../../../../../../common/utils/aceEditorTheme";

const Body = ({ onChange, action }) => {
  const [value, setValue] = useState("");
  const [mode, setMode] = useState("json");
  const render = useSelector((state) => state.integration.render);

  useEffect(() => {
    setValue(action?.body ? action?.body : "");

    if (action?.headers) {
      const headerValue = getHeaderValueByKey(action?.headers, "Content-Type");
      if (ContentType.XML === headerValue) {
        setMode("xml");
      } else if (ContentType.TEXT === headerValue) {
        setMode("text");
      } else {
        setMode("json");
      }
    }
  }, [action, render]);

  const onChangeBody = (newVal) => {
    let eventObject = { target: { name: "body", value: value } };
    eventObject.target.value = newVal;
    onChange(eventObject);
    setValue(newVal);
  };

  const prettifyBody = () => {
    if (mode !== "json" || !value?.trim()) {
      return;
    }

    try {
      const formattedJson = JSON.stringify(JSON.parse(value), null, 2);
      onChangeBody(formattedJson);
    } catch (err) {
      console.warn("Unable to prettify body. Invalid JSON.", err);
    }
  };

  const isPrettifyDisabled = mode !== "json" || !value?.trim();

  return (
    <>
      <AceEditor
        className="ihub-action-body-editor"
        mode={mode}
        theme={getAceEditorTheme()}
        onChange={onChangeBody}
        name="body"
        editorProps={{ $blockScrolling: true }}
        value={value}
        showPrintMargin={false}
      />
      <div className="ihub-action-body-controls">
        <button
          type="button"
          className="ihub-action-prettify-btn"
          onClick={prettifyBody}
          disabled={isPrettifyDisabled}
        >
          Prettify
        </button>
      </div>
    </>
  );
};
export default Body;
